import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
};

export function wishlistItemId(item) {
  if (!item || typeof item !== "object") return null;
  const id = item.productId ?? item.productID ?? item.id;
  return id == null ? null : String(id);
}

function normalizeWishlistItem(item) {
  const id = wishlistItemId(item);
  if (!id) return null;
  return {
    ...item,
    id: item.id ?? id,
    productId: item.productId ?? item.productID ?? item.id,
    productID: item.productID ?? item.productId ?? item.id,
    addedAt: item.addedAt || new Date().toISOString(),
  };
}

export function dedupeWishlistItems(items) {
  const seen = new Set();
  const normalized = [];
  for (const item of Array.isArray(items) ? items : []) {
    const next = normalizeWishlistItem(item);
    const id = wishlistItemId(next);
    if (!id || seen.has(id)) continue;
    seen.add(id);
    normalized.push(next);
  }
  return normalized.slice(0, 100);
}

const wishListSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    addToWishList: (state, action) => {
      const item = normalizeWishlistItem(action.payload);
      if (!item) return;
      const id = wishlistItemId(item);
      if (state.items.some((existing) => wishlistItemId(existing) === id)) return;
      state.items.unshift(item);
      state.items = state.items.slice(0, 100);
    },
    removeFromWishList: (state, action) => {
      const id = wishlistItemId(action.payload);
      if (!id) return;
      state.items = state.items.filter((item) => wishlistItemId(item) !== id);
    },
    clearWishList: (state) => {
      state.items = [];
    },
    hydrateWishList: (state, action) => {
      state.items = dedupeWishlistItems(action.payload);
    },
  },
});

export const { addToWishList, removeFromWishList, clearWishList, hydrateWishList } =
  wishListSlice.actions;

export const selectWishlistItems = (state) => state.wishlist.items;
export const selectWishlistCount = (state) => state.wishlist.items.length;

export default wishListSlice.reducer;
